import React from 'react';

import {Layout} from '../../components/layout';
import {SectionSeo} from '../../lib/seo';

import css from './14-to-24.page.module.css';

export const Trans14To24Page: React.FC = () => {
	return (
		<Layout>
			<SectionSeo section="trans14to24" />
			<div className={css.page}>
				<table className={css.mdTable}>
					<thead>
						<tr>
							<td>Термин на английском</td>
							<td>Термин 2014</td>
							<td>Термин 2024</td>
							<td>Пояснение</td>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>Equipment</td>
							<td>Снаряжение</td>
							<td>Экипировка</td>
							<td>
								Конфликтует со "снаряжением искателя приключений", разделение перевода слов gear и
								equipment
							</td>
						</tr>
						<tr>
							<td>Expended spell slot</td>
							<td>Использованная ячейка заклинаний</td>
							<td>Потраченная ячейка заклинаний</td>
							<td>Во избежание тавтологии</td>
						</tr>
						<tr>
							<td>Expertise</td>
							<td>Мастерство</td>
							<td>Экспертность</td>
							<td>Конфликтует с другими терминами (к примеру, Weapon Mastery)</td>
						</tr>
						<tr>
							<td>Elemental Attunement</td>
							<td>Сродство со стихией</td>
							<td>Родство со стихией</td>
							<td>Для благозвучия</td>
						</tr>
						<tr>
							<td>Great weapon fighting</td>
							<td>Двуручное оружие</td>
							<td>Бой большим оружием</td>
							<td>Точность перевода</td>
						</tr>
						<tr>
							<td>Vow of Enmity</td>
							<td>Клятва ненависти</td>
							<td>Обет ненависти</td>
							<td>Чтобы отделить Vow от Oath (обет и клятва)</td>
						</tr>
						<tr>
							<td>Draconic Ancestry</td>
							<td>Драконье наследие</td>
							<td>Наследие драконов</td>
							<td>для единообразия с аналогичными особенностями видов</td>
						</tr>
						<tr>
							<td>Background</td>
							<td>Предыстория</td>
							<td>Происхождение</td>
							<td>Новый термин origin теперь происхождение</td>
						</tr>
						<tr>
							<td>Dragonborn</td>
							<td>Драконорожденный</td>
							<td>Драконорождённый</td>
							<td>
								Поменяли, потому что не нашли причин писать через е. По аналогии с новорождённый.
								Переводчик энциклопедии чудовищ и руководства мастера подземелий 2014 из фантомов тоже
								сказал, что надо через ё
							</td>
						</tr>
						<tr>
							<td>Crossbow Expert</td>
							<td>Мастер-арбалетчик</td>
							<td>Эксперт в арбалетах</td>
							<td>Как следствие изменения перевода термина Expertise</td>
						</tr>

						<tr>
							<td>Goodberry</td>
							<td>Вкусные ягоды</td>
							<td>Добряника</td>
							<td>
								Более удачная адаптация согласно нашим опросам + при встрече в тексте сразу понятно, что
								это название ягоды / заклинания, а не какие-то абстрактные вкусные ягоды.
							</td>
						</tr>
						<tr>
							<td>Material component</td>
							<td>Реагент</td>
							<td>Материальный компонент</td>
							<td>
								В 2024 редакции нужно избежать путаницы при сокращении Ритуал (Р) и Реагент (Р). Также с
								точки зрения химии в D&D есть не только реагенты, но и катализаторы, которые не исчезают
								после использования — материальные компоненты общее название для них
							</td>
						</tr>

						<tr>
							<td>Gore</td>
							<td>Бодание</td>
							<td>Рога/Клыки/Бивни</td>
							<td>Решили уточнить, чем атакует, зависит от контекста</td>
						</tr>
						<tr>
							<td>Githzerai monk</td>
							<td>Гитзерай-монах</td>
							<td>Гитзераи-монах</td>
							<td>так как Githzerai как и Githyanki не склоняются по числу</td>
						</tr>
						<tr>
							<td>Githzerai zerth</td>
							<td>Гитзерай-зерт</td>
							<td>Гитзераи-зерт</td>
							<td>так как Githzerai как и Githyanki не склоняются по числу</td>
						</tr>
						<tr>
							<td>Manes</td>
							<td>Mейн</td>
							<td>Ман</td>
							<td>Заменили из-за традиции перевода Manes</td>
						</tr>
						<tr>
							<td>Mummy lord</td>
							<td>Лорд-мумия</td>
							<td>Владыка мумий</td>
							<td></td>
						</tr>
						<tr>
							<td>Nightmare</td>
							<td>Мара</td>
							<td>Кошмар</td>
							<td>
								заменили на более привычное, чтобы не было отсылки на существо из фольклора, с которым
								оно не связано
							</td>
						</tr>
						<tr>
							<td>equipment pack</td>
							<td>комплект снаряжения</td>
							<td>комплект экипировки</td>
							<td>разделение перевода слов gear и equipment</td>
						</tr>
					</tbody>
				</table>
			</div>
		</Layout>
	);
};
